import PropTypes from 'prop-types';
import React from 'react';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';
// helper
import { buildImagePath } from '../../../JobComponents/Company/Image/logo';
// style
import './EmployerLogo.scss';

const logoTransform = {
    default: 'ar_1:1,c_lpad/c_scale,f_auto,q_auto,fl_lossy,w_250',
};

export default class EmployerLogo extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        image: PropTypes.shape({
            src: PropTypes.string.isRequired,
            alt: PropTypes.string,
        }).isRequired,
        companyId: PropTypes.number.isRequired,
        companyUrl: PropTypes.string,
    };

    static defaultProps = {
        companyUrl: null,
    };

    handleMetrics = () => {
        const { companyId } = this.props;
        return EmitMetric({
            misc_event_count: 1,
            misc_event_type: 'vcf-sponsor-logo-click',
            company_id: [companyId],
        });
    };

    renderLogo = () => {
        const { image, companyUrl } = this.props;
        const { src, alt } = image;

        const logoSrc = buildImagePath(src, 'default', logoTransform);

        const imageElement = (
            <img
                className="employer-logo"
                src={logoSrc}
                alt={alt || 'employer-logo'}
            />
        );

        if (!companyUrl) return imageElement;

        return (
            <a
                href={companyUrl}
                onClick={this.handleMetrics}
                target="_blank"
                rel="noopener noreferrer"
            >
                {imageElement}
            </a>
        );
    };

    render() {
        return (
            <div className="component-Events-ParticipatingEmployersGrid-EmployerLogo">
                {this.renderLogo()}
            </div>
        );
    }
}
